// extracted by mini-css-extract-plugin
module.exports = {"shadow":"StaticData_shadow__1BPJZ","staticData":"StaticData_staticData__CEAUc","header":"StaticData_header__3YBaS","tabContainer":"StaticData_tabContainer__1Au2H"};